module.exports = __webpack_public_path__ + "static/media/ball_002_a.e8724cce.png";